import React from "react";
import { WHATSAPP_URL } from "@/lib/api";

/**
 * Floating WhatsApp button — fixed bottom-right, opens WhatsApp chat in a new tab.
 * Has a subtle pulse halo + tooltip on hover.
 */
export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-[60] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" aria-hidden="true" />
      <span className="relative flex items-center justify-center w-16 h-16 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-lg shadow-[#25D366]/40 transition-all duration-300 group-hover:scale-110">
        {/* WhatsApp SVG icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-8 h-8 text-white"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M16.003 3C9.376 3 4 8.376 4 15.003c0 2.65.86 5.1 2.317 7.103L4 29l7.087-2.272a11.95 11.95 0 0 0 4.916 1.066H16C22.626 27.794 28 22.418 28 15.79 28 12.58 26.748 9.564 24.476 7.291A11.93 11.93 0 0 0 16.003 3zm0 21.882h-.003a9.94 9.94 0 0 1-5.067-1.387l-.363-.216-4.205 1.349 1.37-4.1-.236-.376a9.94 9.94 0 0 1-1.522-5.275c0-5.5 4.476-9.976 9.978-9.976 2.665 0 5.17 1.039 7.054 2.925a9.93 9.93 0 0 1 2.922 7.052c0 5.5-4.476 9.976-9.928 10.004zm5.473-7.476c-.3-.15-1.775-.876-2.05-.976-.275-.1-.476-.15-.676.15-.2.3-.776.976-.952 1.176-.175.2-.35.226-.65.075-.3-.15-1.266-.466-2.413-1.488-.892-.795-1.494-1.776-1.67-2.076-.175-.3-.019-.462.132-.612.135-.135.3-.35.45-.526.15-.175.2-.3.3-.5.1-.2.05-.376-.025-.526s-.676-1.626-.926-2.226c-.244-.585-.493-.505-.676-.515l-.575-.01a1.1 1.1 0 0 0-.8.375c-.275.3-1.05 1.026-1.05 2.5s1.075 2.9 1.225 3.1c.15.2 2.116 3.236 5.13 4.536.717.31 1.276.495 1.712.633.72.229 1.375.197 1.893.12.578-.086 1.775-.726 2.025-1.426.25-.7.25-1.3.175-1.425-.075-.125-.275-.2-.575-.35z"/>
        </svg>
      </span>

      {/* Tooltip on hover */}
      <span className="pointer-events-none absolute right-[110%] top-1/2 -translate-y-1/2 mr-2 px-3 py-1.5 rounded-lg bg-forest-600 text-cream-100 text-xs font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 translate-x-1 group-hover:translate-x-0 transition-all duration-300 shadow-md">
        Chat with us on WhatsApp
      </span>
    </a>
  );
}
